import Source, { KnownSource } from '../types/Source'

const sourceList: Partial<{ [key in KnownSource]: Source }> = {
  autotrader: {
    name: 'autotrader',
    displayName: 'AutoTrader',
    logoName: 'AutoTrader'
  },
  clearscore: {
    name: 'clearscore',
    displayName: 'Clearscore',
    logoName: 'ClearscoreLogo'
  },
  clearscorerefinance: {
    name: 'clearscorerefinance',
    displayName: 'Clearscore',
    logoName: 'ClearscoreLogo'
  },
  freedomfinance: {
    name: 'freedomfinance',
    displayName: 'Clearscore',
    logoName: 'ClearscoreLogo'
  },
  'freedomfinance-t1': {
    name: 'freedomfinance-t1',
    displayName: 'Clearscore',
    logoName: 'ClearscoreLogo'
  },
  totallymoney: {
    name: 'totallymoney',
    displayName: 'Totally Money',
    logoName: 'TotallyMoneyLogo'
  },
  moneysupermarket: {
    name: 'moneysupermarket',
    displayName: 'MoneySuperMarket',
    logoName: 'MoneySuperMarketLogo'
  },
  quotesearch: {
    name: 'quotesearch',
    displayName: 'QuoteSearch',
    logoName: 'QuoteSearchLogo'
  },
  choosewisely: {
    name: 'choosewisely',
    displayName: 'ChooseWisely',
    logoName: 'ChooseWiselyLogo'
  },
  motiv: {
    name: 'motiv',
    displayName: 'Motiv',
    logoName: 'MotivLogo'
  },
  motivrefinance: {
    name: 'motiv',
    displayName: 'Motiv',
    logoName: 'MotivLogo'
  },
  allpurposeloans: {
    name: 'motiv',
    displayName: 'Motiv',
    logoName: 'MotivLogo'
  },
  theloanpeople: {
    name: 'theloanpeople',
    displayName: 'The Loan People',
    logoName: 'TheLoanPeopleLogo'
  },
  prograd: {
    name: 'prograd',
    displayName: 'Prograd',
    logoName: 'ProgradLogo'
  },
  '1plus1loans': {
    name: '1plus1loans',
    displayName: '1plus1loans',
    logoName: 'OnePlusOneLoansLogo'
  },
  honkhonk: {
    name: 'honkhonk',
    displayName: 'Honk Honk',
    logoName: 'HonkHonkLogo'
  },
  cardealerreviews: {
    name: 'cardealerreviews',
    displayName: 'Car Dealer Reviews',
    logoName: 'CarDealerReviewsLogo'
  },
  quotezone: {
    name: 'quotezone',
    displayName: 'Quote Zone',
    logoName: 'QuoteZoneLogo'
  },
  compareni: {
    name: 'compareni',
    displayName: 'Compareni',
    logoName: 'CompareniLogo'
  },
  oceanfinance: {
    name: 'oceanfinance',
    displayName: 'Oceanfinance',
    logoName: 'OceanFinanceLogo'
  },
  loantube: {
    name: 'loantube',
    displayName: 'Loantube',
    logoName: 'LoantubeLogo'
  },
  wowcher: {
    name: 'wowcher',
    displayName: 'Wowcher',
    logoName: 'WowcherLogo'
  },
  gocompare: {
    name: 'gocompare',
    displayName: 'GoCompare',
    logoName: 'GoCompareLogo'
  },
  aspire: {
    name: 'aspire',
    displayName: 'Motiv',
    logoName: 'MotivLogo'
  },
  gumtree: {
    name: 'gumtree',
    displayName: 'Gumtree',
    logoName: 'GumtreeLogo'
  },
  yesauto: {
    name: 'yesauto',
    displayName: 'yesauto',
    logoName: 'YesautoLogo'
  },
  wollit: {
    name: 'wollit',
    displayName: 'Wollit',
    logoName: 'WollitLogo'
  },
  carmoola: {
    name: 'carmoola',
    displayName: 'Carmoola',
    logoName: 'CarmoolaLogo'
  },
  experian: {
    name: 'experian',
    displayName: 'Experian',
    logoName: 'ExperianLogo'
  },
  close: {
    name: 'close',
    displayName: 'Close Brothers Finance',
    logoName: 'CloseBrothersLogo'
  },
  ctm: {
    name: 'ctm',
    displayName: 'CompareTheMarke',
    logoName: 'CompareTheMarketLogo'
  }
}

// If adding new logos, you may need to delete the .next folder and then re-run yarn dev for the static files to be regenerated locally.
const getSource = (source?: KnownSource): Source | undefined => (
  source ? sourceList[source] : undefined
)

export default getSource
